<script>
    import ExternalLinkIcon from './svg/ExternalLinkIcon.svelte';
    export let args = [];
</script>

<a href={args[0]} target="_blank" rel="noopener">{args[1]}<ExternalLinkIcon/></a>